import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getAuthLink } from '@/lib/links';
import { HOME_AGENTS } from './homeData';

export function CtaMonday() {
  return (
    <section className="py-24 sm:py-32 bg-[#F3F4F5] border-t border-gray-200/60">
      <div className="max-w-[1360px] mx-auto px-5 sm:px-8 text-center">
        {/* Exact monday.com Slice 13-14 Giant Inline-Avatar Closing Display Typography */}
        <motion.div
          initial={false}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45 }}
          className="max-w-5xl mx-auto"
        >
          <h2 className="text-4xl sm:text-6xl lg:text-[84px] font-medium tracking-[-0.04em] text-[#000000] leading-[1.04] mb-10 flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <span>Built for roofers</span>
            <span className="inline-flex items-center -space-x-3 px-2">
              {HOME_AGENTS.slice(0, 3).map((agent) => (
                <img
                  key={agent.id}
                  src={agent.portrait}
                  alt={agent.name}
                  title={`${agent.name} · ${agent.role}`}
                  className="size-12 sm:size-16 lg:size-20 rounded-full object-cover ring-4 ring-[#F3F4F5] border border-gray-300 shadow-sm"
                />
              ))}
            </span>
            <span>and their agents</span>
          </h2>

          <p className="text-base sm:text-lg text-[#323338] max-w-2xl mx-auto mb-10 leading-relaxed font-normal">
            Stop losing $14,000 roof replacements to voicemail. Deploy your dedicated AI fleet in 15
            minutes and capture every call, takeoff, and escrow draw.
          </p>

          {/* Dual Pill Buttons: Solid Purple "Get Started ->" + Black-Bordered "Book a 15-Min Demo ->" */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <motion.a
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              href={getAuthLink('/register')}
              className="inline-flex min-h-12 items-center justify-center gap-2.5 px-8 py-3.5 rounded-full font-normal text-base bg-[#7950A2] text-white hover:bg-[#68418f] shadow-xs transition-colors"
            >
              <span>Start Free 14-Day Trial</span>
              <ArrowRight className="size-4" />
            </motion.a>

            <motion.a
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              href="/demo"
              className="inline-flex min-h-12 items-center justify-center gap-2.5 px-8 py-3.5 rounded-full font-normal text-base text-[#000000] bg-transparent hover:bg-black/5 border border-[#000000] transition-colors"
            >
              <span>Book a 15-Min Demo</span>
              <ArrowRight className="size-4" />
            </motion.a>
          </div>

          <p className="mt-5 text-xs text-[#676879]">
            No credit card needed &nbsp;✦&nbsp; Free 14-day trial &nbsp;✦&nbsp; Cancel anytime
          </p>
        </motion.div>
      </div>
    </section>
  );
}
